import React from "react";
import Sparkle from "./assets/images/sparkle.webp";

const Learnings = () => {
  const backgroundColor = (() => {
    const url = window.location.href;
    if (url.includes("ecom-project")) return "#FFE0D8";
    else if (url.includes("divido-project")) return "#FFFABF";
    else if (url.includes("pixel-project")) return "#E7EDFF";
    return "transparent";
  })();

  const [flippedCards, setFlippedCards] = React.useState({});

  const handleFlip = (index) => {
    setFlippedCards((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const cards = [
    {
      id: 1,
      text: "Understood how micro interactions (drop down boxes) improve the user experience.",
    },
    {
      id: 2,
      text: "Realized the importance of a simplified checkout process to reduce cart abandonment.",
    },
    {
      id: 3,
      text: "Explored the balance between aesthetics and usability to maintain a clean and engaging design.",
    },
  ];
  const currentUrl = window.location.pathname;
  if (currentUrl.includes("divido-project")) {
    const cardsdivido = [
      {
        id: 1,
        text: "Presenting complex financial data in a clear, concise way enhances user understanding and reduces cognitive load.",
      },
      {
        id: 2,
        text: "Implementing proactive alerts and spending insights helps users stay on top of their finances effortlessly.",
      },
      {
        id: 3,
        text: "Designing with transparency, secure UI elements, and clear permissions builds user confidence in managing finances.",
      },
    ];
    return (
      <>
      <section className="my-5">
        <div className="container">
        <h2 className="fs-36px mb-4 my-5">Learnings</h2>
        <div className="row justify-content-center">
          {cardsdivido.map((card, index) => (
          <div className="col-md-4 my-2" key={card.id}>
            <div
            className={`flip-card ${flippedCards[index] ? "is-flipped" : ""}`}
            tabIndex="0"
            onClick={() => handleFlip(index)}
            >
            <div className="flip-card-inner">
              <div className="flip-card-front" style={{ backgroundColor }}>
              <div className="sparkle-img">
                <img src={Sparkle} alt="Sparkle" />
              </div>
              </div>
              <div className="flip-card-back" style={{ borderColor: backgroundColor }}>
              <p className="fs-24 lh-28x mb-0 p-3">{card.text}</p>
              </div>
            </div>
            </div>
          </div>
          ))}
        </div>
        </div>
      </section>
      </>
    );

  }
  else if (currentUrl.includes("pixel-project")) {
    const cardspixel = [
      {
        id: 1,
        text: "Categorized and searchable templates enhance efficiency by helping users find what they need without frustration.",
      },
      {
        id: 2,
        text: "Easy-to-use design tools and clear navigation improve the editing experience.",
      },
      {
        id: 3,
        text: "Features like \"Recent Designs\" and sorting options help users easily access and manage their work.",
      },
    ];
    return (
      <>
      <section className="my-5">
        <div className="container">
        <h2 className="fs-36px mb-4 my-5">Learnings</h2>
        <div className="row justify-content-center">
          {cardspixel.map((card, index) => (
          <div className="col-md-4 my-2" key={card.id}>
            <div
            className={`flip-card ${flippedCards[index] ? "is-flipped" : ""}`}
            tabIndex="0"
            onClick={() => handleFlip(index)}
            >
            <div className="flip-card-inner">
              <div className="flip-card-front" style={{ backgroundColor }}>
              <div className="sparkle-img">
                <img src={Sparkle} alt="Sparkle" />
              </div>
              </div>
              <div className="flip-card-back" style={{ borderColor: backgroundColor }}>
              <p className="fs-24 lh-28x mb-0 p-3">{card.text}</p>
              </div>
            </div>
            </div>
          </div>
          ))}
        </div>
        </div>
      </section>
      </>
    );

  }
  return (
    <>
      <section className="my-5">
        <div className="container">
        <h2 className="fs-36px mb-4 my-5">Learnings</h2>
          <div className="row justify-content-center">
            {cards.map((card, index) => (
              <div className="col-md-4 my-2" key={card.id}>
                <div
                  className={`flip-card ${flippedCards[index] ? "is-flipped" : ""}`}
                  tabIndex="0"
                  onClick={() => handleFlip(index)}
                >
                  <div className="flip-card-inner">
                    <div className="flip-card-front" style={{ backgroundColor }}>
                      <div className="sparkle-img">
                        <img src={Sparkle} alt="Sparkle" />
                      </div>
                    </div>
                    <div className="flip-card-back" style={{ borderColor: backgroundColor }}>
                      <p className="fs-24 lh-28x mb-0 p-3">{card.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Learnings;
